<template>
    <div class="tab" :id="id" :hg-title="$options.filters.i18n(titleI18n)" :label="label">
        <slot/>
    </div>
</template>
<script>
export default {
    props:{
        id: { type: String },
        titleI18n: {type: String },
        label: {type: String}
    }
}
</script>